module.exports = __webpack_public_path__ + "img/appIcon-fiscal--Status__danger.c269c7c8.svg";